import axiosInstance, { AxiosError, AxiosResponse } from 'axios';
import config from './config';
import { getUserDataLocal, useAuth } from '../context/AuthProvider';
import Toast from '../Toast';
import storage from '../Storage';

export enum ApiErrorReason {
  BLOCKED = 1,
  NOT_APPROVED = 2,
  NOT_VERIFIED_PHONE = 3,
  DELETED = 4,
}

export type ApiResponse<T = any> = AxiosResponse<{
  data: T;
  message?: string;
  token?: string;
  points?: number;
}>;

export type PaginatedApiResponse<T = any> = AxiosResponse<{
  data: T;
  message?: string;
  token?: string;
  points?: number;
  pagination: {
    count: number;
    per_page: number;
    current_page: number;
    total_pages: number;
  };
}>;

export type ApiErrorResponse = AxiosError<{
  message: string;
  reason?: ApiErrorReason;
  errors?: any;
}>;

// Creating axios instance for routes that are api protected
export const axios = axiosInstance.create({
  baseURL: config.baseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

/*
    Add a request interceptor to add authentication token on each request
*/
axios.interceptors.request.use(
  async function (config) {
    const token = storage.get('user')?.token;

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

/*
    Add a response interceptor to handle errors
*/
axios.interceptors.response.use(
  (response): any => {
    response = response.data;
    // if (response['message']) {
    //   Toast.success(response?.message);
    // }

    return response;
  },
  async (error) => {
    error = error?.response;
    const token = storage.get('user')?.token;

    switch (error?.status) {
      case 401:
        if (token) {
          Toast.error('You are not authorized for this action.');
        }
        // autoLogoutUser();
        break;
      case 403:
        Toast.error(error.data.message || 'Access to this action is forbidden.');
        // await logoutUser();
        break;
      case 404:
        Toast.error('Requested resource not found. Please try again.');
        break;
      case 419:
        Toast.error('Session expired. Please login again.');
        // await logoutUser();
        break;
      case 422:
        console.log('UPADNE OVDE');
        Toast.error(error.data.message || 'This action access is forbidden.');
        return Promise.reject({ success: false, error });
        break;
      case 429:
        Toast.warn('Too many requests. Try again later.');
        return Promise.reject({ success: false, error });
        break;
      case 503:
        Toast.warn('Work under construction. Please wait a moment.');
        break;
      default:
        Toast.error('Unexpected error occurred. Please try again alter.');
    }

    return Promise.reject(error);
  }
);

// const isUserAuthenticated = () => {
//   const reduxStore = store.getState();
//   if (reduxStore.auth.user) {
//     return true;
//   }
//   return false;
// };
